module.exports = __webpack_public_path__ + "static/media/year-1-improved-arrow.468b2a4e.svg";